import EmptyTablePlaceholder from 'components/atoms/base-empty-table-placeholder';
import BasePagination from 'components/atoms/base-pagination';
import BaseTableNew from 'components/atoms/base-table/new';
import BaseButton from 'components/atoms/baseButton';
import ArrowLeftRightIcon from 'components/atoms/icons/arrow-left-right';
import SearchIcon from 'components/atoms/icons/search.svg?react';
import { scrollToTop } from 'infrastructure/functions';
import {
  CARE_MANAGERS_PER_PAGE,
  useGetCareManagers,
} from 'infrastructure/hooks/agency-doctor';
import { type SortState } from 'infrastructure/types';
import { useState, type FC } from 'react';
import { useTranslation } from 'react-i18next';

import BulkTransferPatientsModal from '../bulk-transfer-patients-modal';
import { useFilter } from '../filter/use-filter';
import { useCareManagersColumns } from './columns';
import s from './styles.module.scss';

const CareManagersTable: FC = () => {
  const [openModal, setOpenModal] = useState(false);

  const { filter, count, updateFilter } = useFilter();
  const { columns } = useCareManagersColumns({ filter });
  const { isFetching, data } = useGetCareManagers(filter);

  const { t } = useTranslation();

  const toggleOpen = () => {
    setOpenModal((prev) => !prev);
  };

  const emptyTableLabel =
    count === 0
      ? t('labels.noUsersFound')
      : t('labels.noUsersFoundByFiltering');

  const onSort = (field: string, sort: SortState) => {
    if (field === 'fullName') {
      updateFilter({ sortBy: 'name', sortDirection: sort });
    }
    if (field === 'patientCount') {
      updateFilter({ sortBy: 'patientCount', sortDirection: sort });
    }
    if (field === 'undefined' || !field) {
      updateFilter({ sortBy: undefined, sortDirection: undefined });
    }
  };

  return (
    <>
      <div className={s.wrapper}>
        <BulkTransferPatientsModal open={openModal} onCancel={toggleOpen} />
        <div className={s.header}>
          <div className={s.buttonWrapper}>
            <p className={s.users}>
              {t('labels.careManager')}: <span>{data?.count ?? ''}</span>
            </p>
            <BaseButton
              label={t('controls.patientsBulkTransfer')}
              icon={<ArrowLeftRightIcon color="#2C2543" />}
              width="194px"
              onClick={toggleOpen}
              type="secondary"
            />
          </div>
          <BasePagination
            page={filter.page ?? 1}
            total={data?.count}
            align="end"
            onChange={async (newPage) => {
              updateFilter({ page: newPage });
            }}
            pageSize={CARE_MANAGERS_PER_PAGE}
            pageSizeOptions={[]}
            hide={false}
            showSizeChanger={false}
          />
        </div>

        <div className={s.divider} />
        <BaseTableNew
          columns={columns}
          bordered
          loading={isFetching}
          onSort={onSort}
          items={data?.rows ?? []}
          pagination={{
            current: filter.page!,
            pageSize: CARE_MANAGERS_PER_PAGE,
            total: data?.count ?? 0,
            position: ['bottomCenter'],
          }}
          className={s.table}
          onChangePage={(newPage) => {
            scrollToTop();
            updateFilter({ page: newPage });
          }}
          emptyText={
            <EmptyTablePlaceholder
              text={emptyTableLabel}
              icon={<SearchIcon width={100} height={100} />}
              column
              textColor="purple"
            />
          }
        />
      </div>
    </>
  );
};
export default CareManagersTable;
